import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from '@app/services/auth/auth.service';
import { ErrorDiagnosticsService } from '@app/services/error-diagnostics.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})

export class ProfileComponent implements OnInit {

  /****************** Variable declaration ******************/
  userName = '';
  src = '';

  /****************** Input and Output decorators ******************/
  @Input() userId: any;
  @Input() style: any = { width: '100%' };
  @Input() isAPICall: boolean = true

  /**
   * Constructor
   * @param errDiagnosticService 
   * @param authService 
   */
  constructor(private errDiagnosticService: ErrorDiagnosticsService,
    public readonly authService: AuthService) { }

    /** ngOnInit */
  ngOnInit(): void {
    // this.getuserProfile(this.userId)
  }

  /**
   * get the user profile based on id
   * @param userId 
   */
  getuserProfile(userId: string) {
    if (!this.isAPICall) return; //call api when image is needed
    if (this.authService.proxyLogin) return; // if proxy login don't call the api
    this.errDiagnosticService.getUserProfile(userId).subscribe((resp: any) => {
      let resp_data = resp.data.dbResp;
      this.src = resp_data.avatar_url;
      this.userName = resp_data.name;
    })
  }
}
